import { TaskDetailSection } from '@euler/app/flows/task/pages/detail/components/TaskDetailSection';
import { Colors } from '@euler/components/Colors';
import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { Maybe } from '@euler/types';
import { memo } from 'react';
import { Text } from 'react-native';

export const ServiceRecordRemarkSection = memo(
  ({ remark }: { remark?: Maybe<string> }) => {
    remark = remark?.trim();
    const { rpx } = useResponsiveContext();
    return (
      <TaskDetailSection
        title="服务备注"
        css={`
          margin-bottom: ${rpx(15)}px;
        `}
      >
        <Text
          css={`
            font-family: ${remark
              ? FontFamily.NotoSans.Regular
              : FontFamily.NotoSans.Light};
            font-size: ${rpx(remark ? 13 : 15)}px;
            color: ${Colors.Gray3};
          `}
        >
          {/* eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing */}
          {remark || '无备注'}
        </Text>
      </TaskDetailSection>
    );
  },
);
